'use strict';

var Core = require('./core');

/* eslint no-invalid-this: 0 */
module.exports = {
    // save created core for each app
    coreList: [],
    windowList: [],

    windowToCoreMap: {},
    core: {},

    getInstance: function ( appWindow ) {
        var self = this,
            index = self.windowList.indexOf(appWindow),
            core;

        if ( index === -1 ) {
            core = new Core();
            core.addListener('hide', function () {
                if ( DEVELOP ) {
                    debug('application')(appWindow.location.href + ' state visible = false');
                }
                this.applicationState.visible = false;
            });
            core.addListener('show', function () {
                if ( DEVELOP ) {
                    debug('application')(appWindow.location.href + ' state visible = true');
                }
                this.applicationState.visible = true;
            });
            core.addListener('focus', function () {
                if ( DEVELOP ) {
                    debug('application')(appWindow.location.href + ' state focused = true');
                }
                this.applicationState.focused = true;
            });
            core.addListener('blur', function () {
                if ( DEVELOP ) {
                    debug('application')(appWindow.location.href + ' state focused = false');
                }
                this.applicationState.focused = false;
            });

            Object.defineProperty(core, 'index', {
                value: self.coreList.push(core) - 1,
                configurable: false,
                enumerable: false,
                writable: false
            });

            self.windowToCoreMap[this.windowList.push(appWindow) - 1] = core.index;
        } else {
            core = self.coreList[this.windowToCoreMap[index]];
        }

        window.top.coreList = this.coreList;
        window.top.windowList = this.windowList;
        window.top.windowToCoreMap = this.windowToCoreMap;

        return core;
    },

    destroy: function ( appWindow ) {
        var index = this.windowList.indexOf(appWindow),
            iterator = 0,
            plugins, keys, keysSize;

        if ( DEVELOP ) {
            if ( appWindow && appWindow.location && appWindow.location.href ) {
                debug('core')(appWindow.location.href + ' destroying');
            }
        }

        if ( index !== -1 ) {
            plugins = this.coreList[this.windowToCoreMap[index]].plugins;
            keys = Object.keys(plugins);
            keysSize = keys.length;

            while ( iterator < keysSize ) {
                if ( typeof plugins[keys[iterator]].destroy === 'function' ) {
                    plugins[keys[iterator]].destroy();
                }
                ++iterator;
            }

            this.coreList[this.windowToCoreMap[index]] = undefined;
            this.windowToCoreMap[this.windowToCoreMap[index]] = undefined;
            this.windowList[index] = undefined;

            return true;
        }

        return false;
    }
};
